import { Button } from '../../../cdl/Button/Button';
import { translate } from '../../../common/helpers/translate.helper';
import { OfferModel } from '../../model/OfferModel';
import { OfferState } from '../../model/OfferState';
import { ConfirmOrderPopup } from '../common/ConfirmOrderPopup';
import { useOfferValidation } from '../common/hooks/useOfferValidation';
import { useSwitchState } from '../common/hooks/useSwitchState';

interface SupplierConfirmButtonProps {
    offer: OfferModel;
}

export const SupplierConfirmButton = (props: SupplierConfirmButtonProps) => {
    const { changeState } = useSwitchState();
    // Prefetch offer validation.
    useOfferValidation(props.offer, true);

    return (
        <Button
            emphasis="high"
            onClick={() => {
                changeState({
                    offer: props.offer,
                    destinationState: OfferState.CONFIRMED,
                    component: ConfirmOrderPopup,
                });
            }}
        >
            {translate('statusbar.supplier.confirmButton')}
        </Button>
    );
};
